import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActionSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 239,
	viewBox: "0 0 308 239",
	width: 308,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m257.552 2.7002h-58.322v68.9909h58.322z",
					fill: "#f4f4f4",
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m257.552 71.6913h1.892v-68.99095h-1.892z",
					fill: "#f4f4f4",
					opacity: .7
				}),
				/* @__PURE__ */ _jsxs("g", {
					fill: "#292a2e",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "m257.552 71.6913h1.892v-68.99095h-1.892z",
							opacity: .05
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m246.928 16.5007h-37.074v41.3913h37.074z",
							opacity: .05
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m246.928 16.5007h-1.932v41.3913h1.932z",
							opacity: .03
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m305.25 90.3212h-47.698v48.0368h47.698z",
					fill: "#f4f4f4",
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m296.561 99.0715h-30.321v30.5355h30.321z",
					fill: "#292a2e",
					opacity: .05
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m305.249 138.357h1.892v-48.0364h-1.892z",
					fill: "#f4f4f4",
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m305.249 138.357h1.892v-48.0364h-1.892z",
					fill: "#292a2e",
					opacity: .05
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m296.561 99.0715h-1.932v30.5355h1.932z",
					fill: "#292a2e",
					opacity: .03
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .7,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m144.917 0h-137.30665v137.023h137.30665z",
					fill: "#f4f4f4",
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m7.61042 0h-1.5738v137.023h1.5738z",
					fill: "#f4f4f4",
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m7.61042 0h-1.5738v137.023h1.5738z",
					fill: "#292a2e",
					opacity: .05
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m40.8731 94.4202v-35.8495h29.4268v20.8277h45.5821v36.8786h19.374v20.746h-19.374-3.732-97.9352v-42.6028z",
					fill: "#292a2e",
					opacity: .05
				}),
				/* @__PURE__ */ _jsxs("g", {
					fill: "#fffffa",
					opacity: .7,
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "m66.5233 62.4631h-21.4291v3.8924h21.4291z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m66.5233 70.5289h-21.4291v3.8924h21.4291z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m66.5233 78.5948h-21.4291v3.8924h21.4291z",
							opacity: .34
						})
					]
				}),
				/* @__PURE__ */ _jsxs("g", {
					fill: "#fffffa",
					opacity: .7,
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "m21.9647 98.1987h-3.9496v3.8923h3.9496z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m21.9647 106.265h-3.9496v3.892h3.9496z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m21.9647 114.33h-3.9496v3.893h3.9496z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m29.2718 98.1987h-3.9495v3.8923h3.9495z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m29.2718 106.265h-3.9495v3.892h3.9495z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m29.2718 114.33h-3.9495v3.893h3.9495z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m36.3806 98.1987h-3.9496v3.8923h3.9496z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m36.3807 106.265h-3.9495v3.892h3.9495z",
							opacity: .34
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m36.3807 114.33h-3.9495v3.893h3.9495z",
							opacity: .34
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m7.61035 67.7428h27.62835v-67.7428h2.2849v67.7428h74.6274v-67.7428h2.285v67.7428h30.481v2.2802h-30.481v67h-2.285v-67h-74.6274v67h-2.2849v-67h-27.62835z",
					fill: "#fff",
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m150.386 136.857h-148.24635v4.557h148.24635z",
					fill: "#f4f4f4",
					opacity: .7
				}),
				/* @__PURE__ */ _jsxs("g", {
					fill: "#292a2e",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "m150.386 136.857h-148.24635v4.557h148.24635z",
							opacity: .1
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m2.1402 136.857h-2.1402v4.557h2.1402z",
							opacity: .1
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m2.1402 136.857h-2.1402v4.557h2.1402z",
							opacity: .1
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m60.0772 17.0154h160.7138c2.315 0 4.535.9177 6.172 2.5513s2.557 3.8493 2.557 6.1596v192.0917c0 2.36-.94 4.624-2.612 6.293-1.673 1.669-3.942 2.607-6.307 2.607h-160.3336c-2.3654 0-4.6339-.938-6.3065-2.607s-2.6123-3.933-2.6123-6.293v-192.0927c.0003-2.3101.92-4.5254 2.5569-6.1588s3.8569-2.551 6.1717-2.5511z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m220.601 227.055h-160.334c-2.4553 0-4.8101-.973-6.5462-2.705-1.7362-1.733-2.7115-4.083-2.7115-6.533v-192.4304c.0002-2.31.9199-4.5254 2.5568-6.1588s3.8569-2.551 6.1717-2.551h161.3912c2.315 0 4.536.9177 6.173 2.5512s2.556 3.8491 2.556 6.1593v192.4297c0 2.45-.975 4.8-2.711 6.533-1.736 1.732-4.091 2.705-6.546 2.705zm-168.9138-201.3447v192.1067c0 1.124.2218 2.238.653 3.277.4312 1.038 1.0631 1.982 1.8599 2.777.7967.795 1.7425 1.426 2.7835 1.856 1.0409.431 2.1566.652 3.2834.652h160.334c2.275 0 4.457-.902 6.066-2.508 1.609-1.605 2.513-3.783 2.513-6.054v-192.1912c0-1.0865-.214-2.1623-.631-3.1661-.417-1.0037-1.028-1.9157-1.798-2.6839s-1.684-1.3775-2.689-1.7931c-1.006-.4157-2.085-.6296-3.173-.6294h-160.8268c-2.2211 0-4.3512.8804-5.9218 2.4477-1.5706 1.5672-2.453 3.6928-2.4532 5.9093z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m85.911 58.7146h-19.4764c-1.0853-.0012-2.1259-.432-2.8934-1.1978-.7676-.7658-1.1994-1.8042-1.2009-2.8873v-19.4365c.0013-1.0832.4331-2.1217 1.2006-2.8877.7676-.766 1.8082-1.1969 2.8937-1.1981h19.4764c1.0855.0011 2.1263.432 2.8939 1.198.7676.7659 1.1995 1.8045 1.2007 2.8878v19.4365c-.0014 1.0832-.4333 2.1216-1.2009 2.8874s-1.8083 1.1966-2.8937 1.1977zm-19.4764-26.9316c-.9057.0011-1.7741.3606-2.4145.9998-.6405.6391-1.0008 1.5057-1.0018 2.4096v19.4371c.001.9039.3613 1.7704 1.0018 2.4096.6404.6391 1.5088.9986 2.4145.9997h19.4764c.9058-.001 1.7742-.3605 2.4147-.9996.6406-.6392 1.0009-1.5058 1.002-2.4097v-19.4365c-.0011-.9039-.3614-1.7705-1.002-2.4097-.6405-.6391-1.5089-.9986-2.4147-.9996z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m85.911 97.2216h-19.4764c-1.0855-.0013-2.1261-.4322-2.8937-1.1982-.7675-.7659-1.1993-1.8044-1.2006-2.8877v-19.4361c.0012-1.0833.4329-2.1219 1.2005-2.888.7676-.766 1.8083-1.1969 2.8938-1.1982h19.4764c1.0855.0013 2.1263.4322 2.8939 1.1982.7677.766 1.1995 1.8047 1.2007 2.888v19.4361c-.0012 1.0833-.4331 2.1219-1.2007 2.8879s-1.8084 1.1968-2.8939 1.198zm-19.4764-26.9307c-.9058.0011-1.7742.3607-2.4146.9999-.6405.6392-1.0008 1.5059-1.0017 2.4098v19.4361c.0009.9039.3612 1.7705 1.0017 2.4097.6405.6391 1.5089.9987 2.4146.9996h19.4764c.9058-.0009 1.7742-.3604 2.4147-.9996.6406-.6391 1.0009-1.5057 1.002-2.4097v-19.4371c-.0011-.904-.3614-1.7706-1.0019-2.4098-.6406-.6392-1.509-.9988-2.4148-.9999z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m85.911 135.729h-19.4764c-1.0855-.002-2.1261-.433-2.8937-1.199-.7675-.766-1.1993-1.804-1.2006-2.887v-19.436c.0013-1.084.4331-2.122 1.2006-2.888.7676-.766 1.8082-1.197 2.8937-1.198h19.4764c1.0855.001 2.1263.432 2.8939 1.198s1.1995 1.804 1.2007 2.888v19.436c-.0012 1.083-.4331 2.122-1.2007 2.888s-1.8084 1.196-2.8939 1.198zm-19.4764-26.932c-.9057.001-1.7741.361-2.4146 1s-1.0008 1.506-1.0017 2.41v19.436c.0009.904.3612 1.77 1.0017 2.409.6405.64 1.5089.999 2.4146 1h19.4764c.9058-.001 1.7742-.36 2.4147-1 .6406-.639 1.0009-1.505 1.002-2.409v-19.436c-.0011-.904-.3614-1.771-1.002-2.41-.6405-.639-1.5089-.999-2.4147-1z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m85.911 173.706h-19.4764c-1.0855-.001-2.1261-.432-2.8937-1.198-.7675-.766-1.1993-1.805-1.2006-2.888v-19.436c.0012-1.083.4329-2.122 1.2005-2.888s1.8083-1.197 2.8938-1.198h19.4764c1.0855.001 2.1263.432 2.8939 1.198.7677.766 1.1995 1.805 1.2007 2.888v19.436c-.0012 1.083-.4331 2.122-1.2007 2.888s-1.8084 1.197-2.8939 1.198zm-19.4764-26.932c-.9058.001-1.7742.361-2.4147 1s-1.0007 1.506-1.0016 2.41v19.436c.001.904.3613 1.771 1.0018 2.41.6404.639 1.5088.998 2.4145.999h19.4764c.9058-.001 1.7742-.36 2.4147-.999.6406-.639 1.0009-1.506 1.002-2.41v-19.436c-.001-.904-.3613-1.771-1.0018-2.41-.6406-.639-1.5091-.999-2.4149-1z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m85.911 211.684h-19.4764c-1.0855-.001-2.1262-.432-2.8938-1.198s-1.1993-1.805-1.2005-2.888v-19.436c.0012-1.083.4329-2.122 1.2005-2.888s1.8083-1.197 2.8938-1.198h19.4764c1.0855.001 2.1263.432 2.8939 1.198.7677.766 1.1995 1.805 1.2007 2.888v19.436c-.0013 1.083-.4332 2.122-1.2008 2.888s-1.8083 1.197-2.8938 1.198zm-19.4764-26.932c-.9058.001-1.7742.361-2.4146 1-.6405.639-1.0008 1.506-1.0017 2.41v19.436c.0009.904.3612 1.77 1.0017 2.41.6404.639 1.5088.998 2.4146.999h19.4764c.9058-.001 1.7742-.36 2.4148-.999.6405-.64 1.0008-1.506 1.0019-2.41v-19.436c-.0011-.904-.3614-1.771-1.0019-2.41-.6406-.639-1.509-.999-2.4148-1z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m72.7081 91.1929c-.3504.0002-.6873-.1352-.9396-.3778l-5.6769-5.446c-.1284-.1232-.2312-.2703-.3026-.4331s-.1099-.338-.1134-.5157c-.0036-.1777.028-.3543.0929-.5197.0649-.1655.1618-.3166.2851-.4447.1234-.1282.2709-.2308.434-.302s.3387-.1097.5167-.1132c.1781-.0035.3551.028.5209.0927s.3172.1614.4456.2846l4.7143 4.5229 11.8165-11.9c.2539-.2507.5968-.3913.954-.3911.3572.0001.6999.1409.9536.3918.2538.2509.3981.5916.4016.948.0035.3565-.1341.6999-.3829.9557l-12.7568 12.8454c-.1258.1274-.2757.2286-.441.2977-.1653.069-.3428.1045-.522.1045z",
			fill: "#038a00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m72.7081 53.193c-.3504.0003-.6873-.1352-.9396-.3778l-5.6769-5.446c-.1284-.1232-.2312-.2703-.3026-.4331s-.1099-.338-.1134-.5157c-.0036-.1776.028-.3542.0929-.5197s.1618-.3166.2851-.4447c.1234-.1281.2709-.2307.434-.302.1631-.0712.3387-.1097.5167-.1132.1781-.0035.3551.028.5209.0927.1658.0648.3172.1615.4456.2846l4.7143 4.5229 11.8165-11.9c.2539-.2507.5968-.3912.954-.3911s.6999.141.9536.3918c.2538.2509.3981.5916.4016.948.0035.3565-.1341.6999-.3829.9557l-12.7568 12.8454c-.1258.1274-.2757.2286-.441.2977-.1653.069-.3428.1046-.522.1045z",
			fill: "#038a00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m72.7081 129.701c-.3504 0-.6872-.135-.9396-.378l-5.6769-5.446c-.2593-.249-.4089-.59-.416-.949-.0072-.358.1288-.705.378-.964s.5912-.408.9508-.415c.3595-.007.7071.128.9664.377l4.7143 4.522 11.8165-11.899c.2531-.255.5973-.4.9569-.401.3596-.002.7051.139.9606.392.2554.252.3998.596.4015.955.0016.359-.1396.703-.3927.958l-12.7568 12.846c-.1258.127-.2757.228-.441.297-.1654.069-.3428.105-.522.105z",
			fill: "#038a00"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#262626",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m214.876 38.8928h-114.226c-.522 0-.9459.4227-.9459.9441s.4239.9441.9459.9441h114.226c.522 0 .946-.4227.946-.9441s-.424-.9441-.946-.9441z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m174.2 49.0408h-73.55c-.522 0-.9459.4227-.9459.9441s.4239.944.9459.944h73.55c.523 0 .947-.4226.947-.944s-.424-.9441-.947-.9441z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m214.876 77.399h-114.226c-.522 0-.9459.4227-.9459.9441s.4239.9441.9459.9441h114.226c.522 0 .946-.4227.946-.9441s-.424-.9441-.946-.9441z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m174.2 87.547h-73.55c-.522 0-.9459.4227-.9459.9441s.4239.9441.9459.9441h73.55c.523 0 .947-.4227.947-.9441s-.424-.9441-.947-.9441z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m214.876 115.906h-114.226c-.522 0-.9459.423-.9459.944s.4239.944.9459.944h114.226c.522 0 .946-.423.946-.944s-.424-.944-.946-.944z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m174.2 126.054h-73.55c-.522 0-.9459.423-.9459.944s.4239.944.9459.944h73.55c.523 0 .947-.423.947-.944s-.424-.944-.947-.944z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m214.876 153.884h-114.226c-.522 0-.9459.423-.9459.944s.4239.944.9459.944h114.226c.522 0 .946-.423.946-.944s-.424-.944-.946-.944z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m174.2 164.032h-73.55c-.522 0-.9459.423-.9459.944s.4239.944.9459.944h73.55c.523 0 .947-.423.947-.944s-.424-.944-.947-.944z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m214.876 191.862h-114.226c-.522 0-.9459.423-.9459.944s.4239.944.9459.944h114.226c.522 0 .946-.423.946-.944s-.424-.944-.946-.944z",
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m174.2 202.01h-73.55c-.522 0-.9459.423-.9459.944s.4239.944.9459.944h73.55c.523 0 .947-.423.947-.944s-.424-.944-.947-.944z",
					opacity: .5
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m296.54 239h-295.559746c-.058348 0-.114306-.053-.155564-.146-.041257-.094-.064436-.221-.064436-.354s.023179-.26.064436-.354c.041258-.093.097216-.146.155564-.146h295.559746c.059 0 .115.053.156.146.041.094.064.221.064.354s-.023.26-.064.354c-.041.093-.097.146-.156.146z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m256.523 194.641c-.09 0-.176-.036-.24-.099-.477-.477-1.256-9.221-3.352-35.255-.858-10.652-1.669-20.714-2.26-26.829-.043-.437-.212-.487-.268-.504-.809-.244-3.272 1.694-4.646 3.39-.028.035-.063.063-.102.084-.039.022-.082.035-.126.04-.044.004-.089 0-.132-.012-.043-.013-.082-.034-.117-.062s-.063-.062-.085-.101c-.021-.039-.034-.082-.039-.126s0-.089.012-.132c.013-.042.034-.082.062-.117.909-1.121 3.871-4.062 5.368-3.612.302.091.678.352.748 1.087.591 6.12 1.402 16.185 2.26 26.84 1.275 15.82 2.718 33.744 3.192 34.872.037.051.058.11.063.173.005.062-.008.124-.036.179-.029.056-.072.102-.125.135-.054.032-.115.049-.177.049z",
			fill: "#494949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m249.8 143.679c5.625-4.5 7.489-11.503 4.164-15.642-3.325-4.14-10.58-3.848-16.205.651s-7.489 11.503-4.164 15.642c3.325 4.14 10.58 3.848 16.205-.651z",
			fill: "#038a00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m249.8 143.679c5.625-4.5 7.489-11.503 4.164-15.642-3.325-4.14-10.58-3.848-16.205.651s-7.489 11.503-4.164 15.642c3.325 4.14 10.58 3.848 16.205-.651z",
			fill: "#fff",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m235.172 145.382c-.033 0-.064-.009-.091-.026s-.049-.042-.063-.071c-.013-.029-.018-.061-.014-.093s.017-.062.037-.087l16.03-19.29c.014-.018.032-.032.051-.043.02-.011.042-.017.064-.02.023-.002.045 0 .067.007.021.006.041.017.059.031.017.015.031.032.042.052.01.02.016.042.018.064.002.023 0 .045-.007.067-.007.021-.018.041-.033.058l-16.03 19.291c-.016.019-.036.034-.058.045-.023.01-.048.016-.072.015z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m260.019 190.505c-.054 0-.107-.013-.155-.038-.048-.024-.09-.06-.121-.104-.032-.044-.052-.095-.059-.149-.008-.053-.003-.108.015-.159l6.021-17.28c.177-.508.479-.963.879-1.324.399-.361.883-.617 1.406-.743.524-.126 1.071-.119 1.592.021.52.139.997.407 1.387.778l3.183 3.036c.065.062.103.147.105.237.002.089-.032.176-.094.241s-.148.103-.238.105-.177-.032-.242-.094l-3.183-3.035c-.307-.292-.684-.504-1.095-.614-.41-.11-.842-.115-1.256-.016-.413.1-.795.301-1.11.586s-.554.644-.694 1.045l-6.021 17.28c-.023.066-.066.124-.124.164-.057.041-.126.063-.196.063z",
			fill: "#494949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m283.061 184.11c4.169-3.293 3.921-10.535-.553-16.175-4.474-5.641-11.48-7.544-15.648-4.251-4.169 3.292-3.921 10.534.553 16.175 4.474 5.64 11.48 7.544 15.648 4.251z",
			fill: "#038a00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m253.788 193.539c-.076 0-.15-.026-.21-.073s-.102-.113-.12-.187l-10.104-42.162c-.069-.288-.216-.55-.425-.76-.209-.209-.472-.357-.76-.427s-.589-.059-.871.031-.534.256-.728.479l-3.115 3.592c-.058.068-.142.11-.232.116-.089.007-.178-.022-.246-.081s-.11-.142-.116-.232c-.007-.089.023-.178.082-.245l3.115-3.592c.275-.318.633-.554 1.034-.682.401-.127.829-.142 1.238-.043.409.1.783.31 1.08.608s.505.671.603 1.08l10.105 42.162c.012.05.012.102.001.152s-.033.096-.065.137c-.031.04-.072.072-.118.094-.046.023-.097.034-.148.034z",
			fill: "#494949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m249.86 163.405c1.226-7.086-2.026-13.561-7.262-14.463-5.237-.902-10.475 4.111-11.7 11.197-1.226 7.086 2.026 13.561 7.262 14.463 5.237.902 10.475-4.111 11.7-11.197z",
			fill: "#038a00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m256.524 194.641c-.015-.001-.029-.001-.042-.003-.045-.006-.087-.02-.126-.042-.039-.021-.073-.051-.1-.086-.028-.035-.048-.075-.06-.118-.012-.042-.015-.087-.009-.131l6.452-52.281c.07-.569.304-1.107.673-1.547s.857-.764 1.406-.934 1.136-.178 1.69-.023c.553.155 1.05.466 1.431.896l7.375 8.336c.06.067.09.156.085.245-.006.09-.047.174-.114.233-.068.059-.156.09-.246.084-.09-.005-.174-.046-.233-.114l-7.375-8.335c-.294-.333-.679-.573-1.106-.693-.428-.12-.882-.114-1.306.017-.425.131-.802.382-1.087.722s-.466.756-.52 1.196l-6.453 52.281c-.01.081-.049.157-.111.211-.062.055-.142.085-.224.086z",
			fill: "#494949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m282.779 153.341c2.573-4.642-.455-11.228-6.763-14.71s-13.507-2.541-16.08 2.101c-2.574 4.642.454 11.228 6.762 14.71s13.507 2.542 16.081-2.101z",
			fill: "#038a00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m283.061 184.11c4.169-3.293 3.921-10.535-.553-16.175-4.474-5.641-11.48-7.544-15.648-4.251-4.169 3.292-3.921 10.534.553 16.175 4.474 5.64 11.48 7.544 15.648 4.251z",
			fill: "#fff",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m249.86 163.405c1.226-7.086-2.026-13.561-7.262-14.463-5.237-.902-10.475 4.111-11.7 11.197-1.226 7.086 2.026 13.561 7.262 14.463 5.237.902 10.475-4.111 11.7-11.197z",
			fill: "#fff",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m282.779 153.341c2.573-4.642-.455-11.228-6.763-14.71s-13.507-2.541-16.08 2.101c-2.574 4.642.454 11.228 6.762 14.71s13.507 2.542 16.081-2.101z",
			fill: "#fff",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m264.777 239h-16.507l-2.735-52.702h21.977z",
			fill: "#292a2e"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m264.777 239h-16.507l-2.735-52.702h21.977z",
			fill: "#fff",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m283.062 184.276c-.026 0-.051-.005-.074-.016-.024-.012-.044-.028-.06-.048l-16.202-20.426c-.028-.035-.041-.08-.035-.125.005-.044.028-.085.063-.113s.08-.04.125-.035c.044.005.085.028.113.063l16.202 20.426c.02.025.033.055.036.087.004.031-.002.063-.016.092-.013.028-.035.053-.062.069-.027.017-.058.026-.09.026z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m281.701 154.978c-.036-.001-.071-.013-.1-.034l-20.733-15.107c-.018-.013-.033-.029-.044-.048-.012-.019-.02-.04-.023-.062-.004-.022-.003-.045.003-.066.005-.022.014-.042.027-.06.014-.018.03-.033.049-.045.019-.011.04-.019.062-.023.022-.003.045-.002.066.003.022.005.042.015.06.028l20.735 15.108c.028.021.049.051.06.085.01.033.01.07-.001.104-.012.033-.033.062-.062.083s-.064.032-.099.032z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m237.509 172.376c-.015 0-.03-.002-.044-.006-.043-.011-.08-.04-.103-.078-.022-.039-.028-.085-.017-.129l6.6-24.677c.006-.022.016-.042.029-.06s.03-.033.05-.045c.019-.011.041-.018.063-.022.022-.003.045-.001.067.005.021.005.042.015.059.029.018.014.033.031.044.051.011.019.018.041.021.063s.001.045-.005.066l-6.6 24.678c-.01.035-.031.067-.061.09-.029.023-.066.035-.103.035z",
			fill: "#fff"
		})
	]
});
export { SvgActionSuccess as ReactComponent };
